import { FSMCommonTransitions, Events } from '../../constants'
import { StatesConfigType } from '../../config'

const { INVOICES, MY_PAGES } = FSMCommonTransitions

export default (FLOW_MACHINE_ID: string): StatesConfigType => ({
  [INVOICES]: {
    on: {
      [Events.BACK]: `#${FLOW_MACHINE_ID}.${MY_PAGES}`,
    },
  },
})
